import React from 'react';
import { connect } from 'react-redux';

import { closeDeeplinkBanner } from 'depop/state/overlays';
import { isBannerPlatform } from 'depop/utils/deeplinks';

import AppBanner from './AppBanner';


class DeeplinkBanner extends React.Component {
  props: {
    overlays: Object,
    userAgent: Object,
    onClose: () => void,
  };

  constructor(props) {
    super(props);
    this.state = {mounted: false};
  }

  componentDidMount() {
    this.setState({mounted: true});
  }

  render() {
    const { userAgent, overlays, onClose } = this.props;
    const { mounted } = this.state;

    if (mounted && isBannerPlatform(userAgent.platform)) {
      return <AppBanner close={onClose} open={overlays.open} {...overlays.deeplinkBanner} />;
    }
    return null;
  }
}

const mapStateToProps = ({userAgent, overlays}) => ({
  userAgent,
  overlays,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: () => dispatch(closeDeeplinkBanner()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeeplinkBanner);



// WEBPACK FOOTER //
// ../src/client/components/banners/DeeplinkBanner.js